import { createContext } from 'react';
import { AuthInfo, AuthenticatedAuthInfo } from '@utils/api/admin';

export type AdminAuthContextValue = {
  authInfo: AuthInfo<Pick<AuthenticatedAuthInfo, 'userInfo' | 'tenantInfo'>> | null
}

export const AdminAuthContext = createContext<AdminAuthContextValue>({
  authInfo: null,
});
